import React from "react";
import { OneLineShowMore } from "@sscs/ui";
import { ROOT_FILE_PATH } from "../../../constants";
const Path = ({ path }) => {
    return React.createElement(OneLineShowMore, { value: path ? path : ROOT_FILE_PATH });
};
export default Path;
//# sourceMappingURL=Path.js.map